import React, { useContext } from 'react'
import "./Servi.css"
import { UserContext } from '../../App';
import app from '../../assets/icons/app.png';
import code from '../../assets/icons/code.png';
import uiux from '../../assets/icons/ux-design.png';
import edit from '../../assets/icons/edit.png';
import video from '../../assets/icons/video.png';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants'
import { Link } from 'react-router-dom';
import { IoMdPhotos } from "react-icons/io";
import { MdVideoCameraBack } from "react-icons/md";
import { CgWebsite } from "react-icons/cg";
import { FaLaptopCode } from "react-icons/fa";
import { MdAppShortcut } from "react-icons/md";

function Services() {
  const {theme,setTheme}=useContext(UserContext)
  return (
    <>

    <main className={theme==0?'servi-main-light':'servi-main-dark'}>
      <center style={{marginBottom:"2rem"}} className={theme==0?'name-light':'name-dark'}>My Services</center>
    <div className='item-list'>
    <motion.section 
    variants={fadeIn("up",0.2)}
    initial="hidden"
    whileInView={"show"}
    viewport={{once:false,amount:0.7}}
     className={theme==0?'servi-item-light':'servi-item-dark'}>
      
        <IoMdPhotos/>
      
      <div >
        <h3 id="servi-title">Photo Editing</h3>
        <div>
        Photo editing involves modifying and enhancing images to improve their quality, adjust their appearance.which includes Color Correction, Retouching, Graphical adge correction etc.
        </div>
        <div>
          <h4 id="servi-title">Tools - </h4>
          <p>Photoshop, Lightroom, PicsArt. </p>
          <Link to="/photoedits"><button id='btnn' style={{cursor:"pointer"}}>Explore My Work</button></Link>

          
        </div>
      </div>
    </motion.section>
    <motion.section 
    variants={fadeIn("up",0.2)}
    initial="hidden"
    whileInView={"show"}
    viewport={{once:false,amount:0.7}}
     className={theme==0?'servi-item-light':'servi-item-dark'}>
      <MdVideoCameraBack/>
      <div >
        <h3 id="servi-title">Video Editing</h3>
        <div>
         i work to manipulating and rearraning video footage to create a final product that means specific goals . it involves transitions, Effects , Text Animations, Speed Adjustment, Exporting and Compression etc. 
        </div>
        <div>
          <h4 id="servi-title">Tools - </h4>
          <p>After Effects, Alight Motion, Capcut, Topaz, etc.</p>
          <Link to="/videoedits"><button id='btnn' style={{cursor:"pointer"}}>Explore My Work</button></Link>
        </div>
      </div>
    </motion.section>
    
    <motion.section 
    variants={fadeIn("up",0.2)}
    initial="hidden"
    whileInView={"show"}
    viewport={{once:false,amount:0.7}}
    className={theme==0?'servi-item-light':'servi-item-dark'}>
      <FaLaptopCode/>
      <div>
        <h3 id='servi-title'>Front-end Development</h3>
        <div>
         High-quality development of sites at the professional level in Full Stack Web Applications.
        </div>
        <div className='tools'>
          <h4 id="servi-title">Technologies -</h4>
          <p>React.js,Next.js, JavaScript,TypeScript, CSS, Bootstrap, Tailwind CSS and MUI.</p>
          <Link to="/projects"><button id='btnn' style={{cursor:"pointer"}}>Explore My Work</button></Link>

        </div>
      </div>
    </motion.section>
    <motion.section 
    variants={fadeIn("up",0.2)}
    initial="hidden"
    whileInView={"show"}
    viewport={{once:false,amount:0.7}}
    className={theme==0?'servi-item-light':'servi-item-dark'}>
      <CgWebsite/>
      <div >
        <h3 id="servi-title">Back-end Development</h3>
        <div>
         Managing the components of a web application that users don't see directly. which includes server managemnet, database management, application, login ,api's ,  etc.
        </div>
        <div>
          <h4 id="servi-title">Technologies -</h4>
          <p>Express.js , Node.js, MongoDB (Compase, Atlas), Javascript.</p>
          <Link to="/projects"><button id='btnn' style={{cursor:"pointer"}}>Explore My Work</button></Link>

        </div>
      </div>
    </motion.section>
    <motion.section 
    variants={fadeIn("up",0.2)}
    initial="hidden"
    whileInView={"show"}
    viewport={{once:false,amount:0.7}}
     className={theme==0?'servi-item-light':'servi-item-dark'}>
      <MdAppShortcut/>
      <div >
        <h3 id="servi-title">UI/UX Design , App Design</h3>
        <div>
         Designing the visual elements of the interface, including layout, color schemes and typography . Proptotyinging implements user interactionn with application.
        </div>
        <div>
          <h4 id="servi-title">Technologies -</h4>
          <p>Figma, Canva, Photoshop.</p>
          <Link to="/projects"><button id='btnn' style={{cursor:"pointer"}}>Explore My Work</button></Link>


        </div>
      </div>
    </motion.section>

    
    
    </div>
    </main>
    </>
  )
}

export default Services